<template>
   <div class="content work_wrapper search_content simple_content">
        <v-row class="search_box">
            <v-col>
              <topNav></topNav>
            </v-col>
        </v-row>
        <div class="userInfo_wrapper">
            <v-row class="">
                <v-col sm="12" md="12">
                    <div class="center_box">
                        <div class="box_title">历史语句</div>
                        <div class="common_tabs">
                            <v-tabs>
                                <v-tab key="1">保存的检索式</v-tab>
                                <v-tab key="2">历史记录</v-tab>
                                <v-tab-item key="1">
                                    <div class="tabs_wrapper">
                                        <strategyList></strategyList>
                                    </div>
                                </v-tab-item>
                                <v-tab-item key="2">
                                    <div class="tabs_wrapper">
                                        <v-data-table
                                            item-key="id"
                                            :headers="headers"
                                            :items="historyList"
                                            class="elevation-1"
                                        >
                                        </v-data-table>
                                    </div>
                                </v-tab-item>
                            </v-tabs>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </div>
   </div>
</template>
<script>
import topNav from "@/components/widgets/topNav.vue";
import strategyList from "@/components/strategy/list.vue";
import {mapActions} from 'vuex'
export default {
    data() {
        return {
            currentPage:  1,
            pageSize: 20,
            historyList: [],
            headers: [
                {
                    text: '关键词',
                    align: 'start',
                    sortable: false,
                    value: 'keywords'
                },
                {
                    text: 'IP地址',
                    align: 'start',
                    sortable: false,
                    value: 'ip'
                },
                {
                    text: '检索式',
                    align: 'start',
                    sortable: false,
                    value: 'searchFormula'
                },
            ]
        }
    },
    components: {
        topNav,
        strategyList
    },
    mounted() {
        this.$store.commit('setMenuMini', false)
        this.getHistory()
    },
    methods: {
        ...mapActions('search',['getHistoryList']),
        getHistory() {
            let _this = this
             let data = {
                params: {
                    page: this.currentPage,
                    pageSize: this.pageSize
                }
            }
            this.getHistoryList({data: data,handle(res) {
                let list = res.message
                _this.historyList = JSON.parse(list)
            }})
        },
    }
}
</script>